/*
 * Number Counter step 3 demo (snippets/mogrt-demo-counter.liquid), run by
 * assets/mogrt-steps-demo.js: type the end value, the panel sets two
 * decimals and a "$" before the counter, the monitor counts up to it.
 */
(() => {
  const easeOutQuad = (t) => 1 - (1 - t) * (1 - t);
  const format = (n, decimals) => {
    const [whole, part] = n.toFixed(decimals).split('.');
    return whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (part ? `.${part}` : '');
  };
  const parts = (screen) => {
    const number = screen.querySelector('[data-mdc-number]');
    return {
      field: screen.querySelector('[data-eg-text]'),
      before: number.querySelector('[data-mdc-before]'),
      value: number.querySelector('[data-mdc-value]'),
      to: parseFloat(number.dataset.to) || 0,
    };
  };

  window.MogrtDemos = window.MogrtDemos || {};
  window.MogrtDemos.counter = {
    rest(screen) {
      const p = parts(screen);
      p.field.dataset.full = p.field.dataset.full || p.field.textContent.trim();
      p.field.textContent = p.field.dataset.full;
      p.field.classList.remove('is-typing');
      screen.setAttribute('data-live', '');
      p.before.textContent = '$';
      p.value.textContent = format(p.to, 2);
    },
    async pass(screen, t) {
      const p = parts(screen);
      const text = p.field.dataset.full;
      p.before.textContent = '';
      p.value.textContent = '0';
      p.field.textContent = '';
      if (!(await t.wait(500))) return false;
      if (!(await t.type(p.field, text, { speed: 110 }))) return false;
      t.live(true);
      if (!(await t.wait(900))) return false;
      p.before.textContent = '$';
      const start = performance.now();
      const duration = 1720;
      await new Promise((resolve) => {
        const step = (now) => {
          if (!t.alive()) return resolve();
          const k = Math.min(1, (now - start) / duration);
          p.value.textContent = format(p.to * easeOutQuad(k), 2);
          k < 1 ? requestAnimationFrame(step) : resolve();
        };
        requestAnimationFrame(step);
      });
      return t.wait(2600);
    },
  };
})();
